var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2786_5186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4659 4.54766C16.3818 4.21149 16.2104 3.90348 15.9691 3.65474C15.7278 3.406 15.4252 3.22534 15.0917 3.131C13.8734 2.8335 9.00008 2.8335 9.00008 2.8335C9.00008 2.8335 4.12675 2.8335 2.90841 3.15933C2.57496 3.25367 2.27231 3.43433 2.03103 3.68308C1.78975 3.93182 1.61839 4.23983 1.53425 4.576C1.31127 5.81243 1.2022 7.06672 1.20841 8.32308C1.20046 9.5889 1.30954 10.8528 1.53425 12.0985C1.62701 12.4242 1.80221 12.7205 2.04293 12.9588C2.28365 13.197 2.58174 13.3691 2.90841 13.4585C4.12675 13.7843 9.00008 13.7843 9.00008 13.7843C9.00008 13.7843 13.8734 13.7843 15.0917 13.4585C15.4252 13.3642 15.7278 13.1835 15.9691 12.9348C16.2104 12.686 16.3818 12.378 16.4659 12.0418C16.6872 10.8147 16.7962 9.56998 16.7917 8.32308C16.7997 7.05726 16.6906 5.79341 16.4659 4.54766Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40633 10.6393L11.4792 8.32308L7.40633 6.00683V10.6393Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2786_5186"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.77f1034932cec7ff38599ec4c7919358.svg";
export { ForwardRef as ReactComponent };